// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face { font-family: "agora"; src: url("fonts/agora-0a2b271da12c39ec025904db6cf325c5.svg#agora") format("svg"),
url("fonts/agora-6770cfca89c29a77bc84efc54f49852a.ttf") format("truetype"),
url("fonts/agora-9b3d043fc9ecaf20589b32e4fdaaa4ee.woff") format("woff"),
url("fonts/agora-6c5bd994d63b748a40d58f37c0aee78b.woff2") format("woff2"),
url("fonts/agora-36faecd1bd28e06cff3a337af7755894.eot?#iefix") format("embedded-opentype"); } 

.ai { 
	line-height: 1; 
	display: inline-block; 
	font: normal normal normal 14px/1 agora; 
	text-rendering: auto; 
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale; 
} 

.ai:before { 
	vertical-align: middle; 
	margin-top: -4px; 
	display: inline-block;
} 

.ai-align-bottom:before { 
	content: "\\f101"; 
} 
.ai-align-top:before { 
	content: "\\f102"; 
} 
.ai-align-top2:before { 
	content: "\\f103"; 
} 
.ai-decrement-height:before { 
	content: "\\f104"; 
} 
.ai-decrement-width:before { 
	content: "\\f105"; 
} 
.ai-report-flat:before { 
	content: "\\f106"; 
} 
.ai-report-grouped:before { 
	content: "\\f107"; 
} 
.ai-roboto-mono-v7-latin-regular:before { 
	content: "\\f108"; 
} 
.ai-sale-center:before { 
	content: "\\f109"; 
} 
.ai-workplace:before { 
	content: "\\f10a"; 
} 
`, "",{"version":3,"sources":["webpack://./src/core/fonts/agora.font"],"names":[],"mappings":"AAAA,aAAa,oBAAoB,EAAE;;;;0FAIuD,EAAE;;AAE5F;CACC,cAAc;CACd,qBAAqB;CACrB,uCAAuC;CACvC,oBAAoB;CACpB,mCAAmC;CACnC,kCAAkC;AACnC;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB","sourcesContent":["@font-face { font-family: \"agora\"; src: url(\"fonts/agora-0a2b271da12c39ec025904db6cf325c5.svg#agora\") format(\"svg\"),\nurl(\"fonts/agora-6770cfca89c29a77bc84efc54f49852a.ttf\") format(\"truetype\"),\nurl(\"fonts/agora-9b3d043fc9ecaf20589b32e4fdaaa4ee.woff\") format(\"woff\"),\nurl(\"fonts/agora-6c5bd994d63b748a40d58f37c0aee78b.woff2\") format(\"woff2\"),\nurl(\"fonts/agora-36faecd1bd28e06cff3a337af7755894.eot?#iefix\") format(\"embedded-opentype\"); } \r\n\r\n.ai { \r\n\tline-height: 1; \r\n\tdisplay: inline-block; \r\n\tfont: normal normal normal 14px/1 agora; \r\n\ttext-rendering: auto; \r\n\t-webkit-font-smoothing: antialiased;\r\n\t-moz-osx-font-smoothing: grayscale; \r\n} \r\n\r\n.ai:before { \r\n\tvertical-align: middle; \r\n\tmargin-top: -4px; \r\n\tdisplay: inline-block;\r\n} \r\n\r\n.ai-align-bottom:before { \r\n\tcontent: \"\\f101\"; \r\n} \r\n.ai-align-top:before { \r\n\tcontent: \"\\f102\"; \r\n} \r\n.ai-align-top2:before { \r\n\tcontent: \"\\f103\"; \r\n} \r\n.ai-decrement-height:before { \r\n\tcontent: \"\\f104\"; \r\n} \r\n.ai-decrement-width:before { \r\n\tcontent: \"\\f105\"; \r\n} \r\n.ai-report-flat:before { \r\n\tcontent: \"\\f106\"; \r\n} \r\n.ai-report-grouped:before { \r\n\tcontent: \"\\f107\"; \r\n} \r\n.ai-roboto-mono-v7-latin-regular:before { \r\n\tcontent: \"\\f108\"; \r\n} \r\n.ai-sale-center:before { \r\n\tcontent: \"\\f109\"; \r\n} \r\n.ai-workplace:before { \r\n\tcontent: \"\\f10a\"; \r\n} \r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
